export default __webpack_public_path__ + "9d57b9e7eb7ccb70e309c959e7c5580e.png";